var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLogo = function SvgLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 457 462"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#80F",
    d: "M456.324 461.059V.334L302.185 199.76l-15.047 19.467-58.918 76.23-59.495-76.974-15.047-19.468L.114.335v460.724h89.613V290.201l-41.876-54.18v135.516l-9.742-12.604V206.624l9.742 12.603 41.876 54.18 13.438 17.386 108.467 140.335c8.393 10.858 24.782 10.858 33.175 0l107.892-139.59 14.013-18.131 41.877-54.18 9.741-12.603v152.309l-9.741 12.604V236.021l-41.877 54.18v170.858z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#171717",
    strokeWidth: 0.228,
    d: "M211.632 431.128 103.165 290.793l-13.438-17.386-41.876-54.18-9.742-12.603v152.309l9.742 12.604V236.021l41.876 54.18v170.858H.114V.334l153.564 198.681 15.047 19.468 59.495 76.974 58.918-76.23 15.047-19.467L456.324.334V461.06h-89.612V290.201l41.877-54.18v135.516l9.741-12.604V206.624l-9.741 12.603-41.877 54.18-14.013 18.131-107.892 139.59m-33.175 0c8.393 10.858 24.782 10.858 33.175 0m-33.175 0c8.393 10.858 24.782 10.858 33.175 0"
  })));
};
export default SvgLogo;